import { getDepartments } from "services/departments.service";
import { useQuery  } from "react-query";

export const useDepartments = (hierarchy) => {
  return useQuery(["departments", hierarchy], () => getDepartments(hierarchy));
};
